import { useMemo } from 'react';
import { FilterChoice } from '../../common/components/SearchHeader/types/FilterChoice';
import { spliced } from '../../common/util/spliced';
import { GENERAL_PRACTICE, PAGE_SIZE } from '../constants';
import { SearchResultItem } from '../types';

export const showTeleSuggestion = (filters: FilterChoice, searchSpecialty?: string): boolean =>
  // Dont show if already filtering for telehealth
  filters.flag !== 'telehealth' &&
  // Only show for GP searches
  searchSpecialty === GENERAL_PRACTICE;

// Add a suggestion either, as the first item of the second page, or the last item on a single page
export const addSuggestion = (
  profile: SearchResultItem,
  profiles: SearchResultItem[],
  position: number = PAGE_SIZE,
): SearchResultItem[] => spliced<SearchResultItem>(profiles, position, 0, profile);

export const useSuggestionCards = (
  searchResults: SearchResultItem[],
  filters: FilterChoice,
  searchSpecialty?: string,
) =>
  useMemo((): SearchResultItem[] => {
    if (showTeleSuggestion(filters, searchSpecialty)) {
      const suggestion: SearchResultItem = { type: 'suggestion', id: 'gpOrTelehealth' };

      return addSuggestion(suggestion, searchResults, 6);
    }

    return searchResults;
  }, [searchResults, searchSpecialty, filters]);
